/**
 * DateInput Component
 *
 * Single date picker for date/timestamp field filters.
 * Used for operators: EQUAL, NOT_EQUAL, GT, GE, LT, LE
 */

import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'

interface DateInputProps {
  value?: string
  onChange: (value: string | null) => void
  placeholder?: string
}

export function DateInput({ value, onChange, placeholder }: DateInputProps) {
  // Convert string value to dayjs object
  const dayjsValue: Dayjs | null = value ? dayjs(value) : null

  // Handle change and convert back to ISO string
  const handleChange = (date: Dayjs | null) => {
    // Store as ISO string (YYYY-MM-DD format for dates)
    onChange(date ? date.format('YYYY-MM-DD') : null)
  }

  return (
    <DatePicker
      value={dayjsValue}
      onChange={handleChange}
      placeholder={placeholder || 'Select date'}
      style={{ width: '100%' }}
      format="YYYY-MM-DD"
    />
  )
}
